import React, { useState } from "react";
import Navbar from "./Navbar.js";
import useFetch from "./useFetch.js";
import swal from "sweetalert";
import $ from "jquery";
import AlarmsTable from "./tables/AlarmsTable.js";
import config from "../config.js";
import Cookie from "universal-cookie";
import {
  Box,
  Typography,
  Button,
  TextField,
  Card,
  CardContent,
  Grid,
  Divider,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import { Bell, Calendar, Search, Database, AlertCircle } from "lucide-react";

const Alarms = () => {
  const cookies = new Cookie();
  let actionInitiatingUser = -1;
  try {
    actionInitiatingUser = cookies.get("userID");
  } catch (error) {}

  const {
    isPending: isPendingAlarms,
    data: alarms,
    setData: setAlarms,
    error: errorAlarms,
  } = useFetch({
    actionInitiatingUser: { userID: actionInitiatingUser },
    URL: config.BACKEND_URL + "/logger_alarm",
  });
  const {
    isPending: isPendingTempAlarms,
    data: tempAlarms,
    setData: setTempAlarms,
    error: errorTempAlarms,
  } = useFetch({
    actionInitiatingUser: { userID: actionInitiatingUser },
    URL: config.BACKEND_URL + "/logger_alarm",
  });
  const {
    isPending: isPendingAlarmSettings,
    data: alarmSettings,
    setData: setAlarmSettings,
    error: errorAlarmSettings,
  } = useFetch({
    actionInitiatingUser: { userID: actionInitiatingUser },
    URL: config.BACKEND_URL + "/alarms",
  });
  const {
    isPending: isPendingSources,
    data: sources,
    setData: setsources,
    error: errorSources,
  } = useFetch({
    actionInitiatingUser: { userID: actionInitiatingUser },
    URL: config.BACKEND_URL + "/logger_sources/sources",
  });

  let tempStartDateTime = "",
    tempEndDateTime = "";

  const handleAlarmsSubmit = (e) => {
    e.preventDefault();
    if (tempStartDateTime === "" || tempEndDateTime === "") {
      swal(
        "Start time and end time cannot be unspecified!",
        "Please specify valid date-times.",
        "error"
      );
      return;
    }
    if (!areDatesValid(tempStartDateTime, tempEndDateTime)) {
      swal(
        "Start time and end time cannot be invalid!",
        "Please specify valid date-times.",
        "error"
      );
      return;
    } else {
      let tempAlarms = alarms.filter((alarm) => {
        return (
          alarm.createdAt < tempEndDateTime &&
          alarm.createdAt > tempStartDateTime
        );
      });
      $("#startDate")[0].value = "";
      $("#endDate")[0].value = "";
      tempStartDateTime = "";
      tempEndDateTime = "";
      setTempAlarms(tempAlarms);
    }
  };

  const handleStartTime = (e) => {
    tempStartDateTime = e.target.value;
    if (e.target.value === "") {
      swal(
        "Start time cannot be unspecified!",
        "Please specify a start date-time.",
        "error"
      );
    } else if (!areDatesValid(tempStartDateTime, tempEndDateTime)) {
      swal(
        "Start time must be before end time!",
        "Please specify valid start time.",
        "error"
      );
    }
  };

  const handleEndTime = (e) => {
    tempEndDateTime = e.target.value;
    if (e.target.value === "") {
      swal(
        "End time cannot be unspecified!",
        "Please specify an end date-time.",
        "error"
      );
    } else if (!areDatesValid(tempStartDateTime, tempEndDateTime)) {
      swal(
        "End time must be after start time!",
        "Please specify a valid end time.",
        "error"
      );
    }
  };

  const areDatesValid = (firstDate = "", secondDate = "") => {
    return (
      firstDate.length === 0 ||
      secondDate.length === 0 ||
      firstDate <= secondDate
    );
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0f1729", pb: 6 }}>
      <Navbar />

      <Box sx={{ p: 4, maxWidth: "1300px", mx: "auto", mt: 4 }}>
        {/* Header Section */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 4 }}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: "white" }}>
              Alarms Log
            </Typography>
            <Typography
              sx={{
                fontSize: "1.1rem",
                color: "rgba(255,255,255,0.7)",
                mt: 0.5,
              }}
            >
              Review historical alarm records and system triggers.
            </Typography>
          </Box>
        </Box>

        {/* Filter Card */}
        <Card
          elevation={0}
          sx={{
            background: "rgba(15, 23, 42, 0.6)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            color: "white",
            borderRadius: "16px",
            border: "1px solid rgba(148, 163, 184, 0.15)",
            boxShadow:
              "0 0 0 1px rgba(255,255,255,0.05), 0 4px 12px rgba(49, 56, 163, 0.2)",
            p: 3,
            mb: 4,
          }}
        >
          <Box sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
            <Calendar size={20} color="#60a5fa" />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Filter by Time
            </Typography>
          </Box>

          <Divider sx={{ borderColor: "#1e293b", mb: 3 }} />

          <form onSubmit={handleAlarmsSubmit}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={5}>
                <TextField
                  fullWidth
                  label="From"
                  type="datetime-local"
                  id="startDate"
                  onChange={handleStartTime}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "#94a3b8" },
                  }}
                  sx={{
                    input: { color: "white" },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#334155" },
                      "&:hover fieldset": { borderColor: "#60a5fa" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <TextField
                  fullWidth
                  label="To"
                  type="datetime-local"
                  id="endDate"
                  onChange={handleEndTime}
                  InputLabelProps={{
                    shrink: true,
                    style: { color: "#94a3b8" },
                  }}
                  sx={{
                    input: { color: "white" },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": { borderColor: "#334155" },
                      "&:hover fieldset": { borderColor: "#60a5fa" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  sx={{
                    bgcolor: "#3b82f6",
                    color: "white",
                    py: 1.5,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    "&:hover": { bgcolor: "#2563eb" },
                  }}
                >
                  Get Alarms
                </Button>
              </Grid>
            </Grid>
          </form>
        </Card>

        {/* Status / Table Section */}
        <Box sx={{ mt: 2 }}>
          {(isPendingAlarms || isPendingAlarmSettings || isPendingSources) && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                py: 8,
              }}
            >
              <CircularProgress sx={{ color: "#3b82f6", mb: 2 }} />
              <Typography sx={{ color: "rgba(148,163,184,0.8)" }}>
                Fetching alarm records...
              </Typography>
            </Box>
          )}

          {(errorAlarms || errorAlarmSettings || errorSources) && (
            <Box sx={{ textAlign: "center", py: 8, color: "#ef4444" }}>
              <AlertCircle size={48} style={{ marginBottom: "16px" }} />
              <Typography variant="h6">
                Cannot fetch the alarms right now!
              </Typography>
            </Box>
          )}

          {alarms && alarmSettings && sources && (
            <Box>
              {alarms.length === 0 ? (
                <Box
                  sx={{
                    py: 10,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: "#1e293b",
                    borderRadius: "16px",
                    border: "1px solid #334155",
                    textAlign: "center",
                  }}
                >
                  <Bell size={60} color="#64748b" />
                  <Typography variant="h6" sx={{ mt: 2, color: "#cbd5e1" }}>
                    Currently, there are no alarm records!
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    bgcolor: "#0f1729",
                    borderRadius: "16px",
                    border: "1px solid #1e293b",
                    p: 1,
                    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.4)",
                  }}
                >
                  <AlarmsTable
                    alarmSettings={alarmSettings}
                    alarms={tempAlarms}
                    sources={sources.data}
                  />
                </Box>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Alarms;
